import { getCore as get, postCore as post, delCore as del, putCore as put } from "../../../utils/httpInterceptor";

class cmtItemvenddescriptionsServiceGen {

  // Legacy endpoints don't require tenant ID in the URL
  static getApiPath(endpoint) {
    return `/api/legacy/${endpoint}`;
  }

  // Build query string for pagination, sort and filter parameters
  static buildQueryString(page = 0, pageSize = 100, sort = [], filters = {}) {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('size', pageSize.toString());
    
    // Spring Boot Pageable expects sort in format: sort=field,direction
    // Multiple sort criteria: sort=field1,dir1&sort=field2,dir2
    if (sort && sort.length > 0) {
      sort.forEach(sortItem => {
        if (sortItem && sortItem.field && sortItem.direction) {
          params.append('sort', `${sortItem.field},${sortItem.direction}`);
        }
      });
    }
    
    // Add filter parameters
    if (filters && typeof filters === 'object') {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          if (Array.isArray(value)) {
            value
              .filter(item => item !== undefined && item !== null && item !== '')
              .forEach(item => params.append(key, item.toString()));
            return;
          }
          params.append(key, value.toString());
        }
      });
    }
    return params.toString();
  }

  // Build path for composite ID (multiple PK fields)
  static buildIdPath(id) {
    // Simple PK: single field
    return id || '';
  }

  static async list(page = 0, pageSize = 100, sort = [], filters = {}) {
    const queryString = cmtItemvenddescriptionsServiceGen.buildQueryString(page, pageSize, sort, filters);
    const basePath = cmtItemvenddescriptionsServiceGen.getApiPath("cmt-itemvenddescriptions");
    return await get(`${basePath}?${queryString}`);
  }

  static async create(payload) {
    return await post(cmtItemvenddescriptionsServiceGen.getApiPath("cmt-itemvenddescriptions"), payload);
  }

  static async update(id, payload) {
    console.log('[update] id:', id, 'payload:', payload);
    const idPath = cmtItemvenddescriptionsServiceGen.buildIdPath(id);
    console.log('[update] idPath:', idPath);
    return await put(cmtItemvenddescriptionsServiceGen.getApiPath("cmt-itemvenddescriptions") + `/${idPath}`, payload);
  }

  static async delete(id) {
    const idPath = cmtItemvenddescriptionsServiceGen.buildIdPath(id);
    return await del(cmtItemvenddescriptionsServiceGen.getApiPath("cmt-itemvenddescriptions") + `/${idPath}`);
  }

  static async getAll(page = 0, pageSize = 100, sort = [], filters = {}) {
    const data = await cmtItemvenddescriptionsServiceGen.list(page, pageSize, sort, filters);

    // Handle Spring Page response: data.content contains the array, or fallback to data for backward compatibility
    const dataContent = data?.content ?? data;
    const mappedData = Array.isArray(dataContent)
      ? dataContent.map(item => {
          // For composite PK: build id object from flattened fields
          return {
            ...item,
            id: item.id ?? item.recId
          };
        })
      : [];

    return {
      content: mappedData,
      totalElements: data?.totalElements ?? mappedData.length,
      totalPages: data?.totalPages ?? 1
    };
  }

  static async getAllList(page = 0, pageSize = 100, sort = [], filters = {}) {
    const result = await cmtItemvenddescriptionsServiceGen.getAll(page, pageSize, sort, filters);
    return result?.content || [];
  }
}

export default cmtItemvenddescriptionsServiceGen;